import React from 'react';
import PropTypes from 'prop-types';
import FieldSet from '../../../fieldset/FieldSet';
import {
  FULL_REFUND, PARTIAL_REFUND, STANDARD_REFUND, MONEY_REFUND, REFUND_SERVICE_REFUND, POS_REFUND, WORLDPAY_EXPRESS,
} from '../Constants';

class RefundOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isBillRefund: false,
      isMoneyOnlyRefund: false,
      isFullRefund: false,
      isPartialRefund: false,
      isPosRefund: false,
      isRefundServiceRefund: false,
    };
  }

  onFullRefundClick() {
    this.setState({
      isPartialRefund: false,
      isFullRefund: true,
    });
  }

  onPartialRefundClick() {
    this.setState({
      isFullRefund: false,
      isPartialRefund: true,
    });
  }

  onBillRefundClick() {
    this.setState({
      isBillRefund: true,
      isMoneyOnlyRefund: false,
      isRefundServiceRefund: false,
    });
  }

  onMoneyOnlyClick() {
    this.setState({
      isBillRefund: false,
      isMoneyOnlyRefund: true,
      isRefundServiceRefund: false,
    });
  }

  onRefundServiceRefundClick() {
    this.setState({
      isBillRefund: false,
      isMoneyOnlyRefund: false,
      isRefundServiceRefund: true,
    });
  }

  onPosClick() {
    this.setState({
      isBillRefund: true,
      isFullRefund: true,
      isPosRefund: true,
    });
  }

  isValid() {
    const {
      isBillRefund, isFullRefund, isPartialRefund, isMoneyOnlyRefund, isRefundServiceRefund,
    } = this.state;
    return (isMoneyOnlyRefund || isBillRefund || isRefundServiceRefund) && (isFullRefund || isPartialRefund);
  }

  getRefundMethod(isBillRefund, isRefundServiceRefund) {
    if (isRefundServiceRefund) { return REFUND_SERVICE_REFUND; }
    return isBillRefund ? STANDARD_REFUND : MONEY_REFUND;
  }

  populateData() {
    const { data, } = this.props;
    const {
      isPartialRefund, isBillRefund, isRefundServiceRefund, isPosRefund,
    } = this.state;
    data.refundType = isPartialRefund ? PARTIAL_REFUND : FULL_REFUND;
    data.refundMethod = this.getRefundMethod(isBillRefund, isRefundServiceRefund);
    data.posRefund = isPosRefund ? POS_REFUND : undefined;
  }

  getRefundView() {
    const {
      isBillRefund, isMoneyOnlyRefund, isRefundServiceRefund,
    } = this.state;
    const isV3 = this.props.data.transaction.version === 3;
    const showCSE = !isV3;
    const showBtps = isV3 || !this.refundingPosTransaction(); // do not show BTPS refunds for V2 POS
    const showRefundService = isV3;
    return (
      <>
        <FieldSet title="Refund Methods" style={{ maxHeight: '500px', marginTop: '20px', }}>
          <button
            style={showCSE ? {} : { display: 'none', }}
            type="button"
            className="btn btn-outline-white"
            onClick={() => this.onBillRefundClick()}
            title="Refund via the CSE"
          >
            <input
              type="radio"
              checked={isBillRefund}
              readOnly
              name="cseRefund"
              onChange={() => {}}
            />
            <span className="m-1">Refund Bill (recommended)</span>
          </button>
          <button
            style={showRefundService ? {} : { display: 'none', }}
            type="button"
            className="btn btn-outline-white"
            onClick={() => this.onRefundServiceRefundClick()}
            title="Refund via refund_service"
          >
            <input
              className="form-control-input"
              type="radio"
              name="refundServiceRefund"
              checked={isRefundServiceRefund}
              onChange={() => {}}
              disabled={this.props.data.transaction.version !== 3}
            />
            <span className="m-1">Standard Refund</span>
          </button>
          <button
            style={showBtps ? {} : { display: 'none', }}
            type="button"
            className="btn btn-outline-white"
            onClick={() => this.onMoneyOnlyClick()}
            title="Refund via BTPS (formerly 'Money Only')"
          >
            <input
              type="radio"
              checked={isMoneyOnlyRefund}
              readOnly
              name="btpsRefund"
              onChange={() => {}}
            />
            <span className="m-1">Legacy Refund (deprecated)</span>
          </button>
        </FieldSet>
        {this.renderRefundTypes()}
      </>
    );
  }

  renderRefundTypes() {
    const { isFullRefund, isPartialRefund, } = this.state;
    const isV3 = this.props.data.transaction.version === 3;
    const partialOnly = this.state.isRefundServiceRefund; // full refund view for refund_service not built out yet, just use partial
    const allowPartial = !isV3 && this.refundingPosTransaction(); // do not allow partial refunds for V2 POS
    return (
      <FieldSet title="Refund Types" style={{ maxHeight: '500px', marginTop: '20px', }}>
        <button
          style={partialOnly ? { display: 'none', } : {}}
          type="button"
          className="btn btn-outline-white"
          onClick={() => this.onFullRefundClick(!isFullRefund)}
        >
          <input
            className="form-control-input"
            type="radio"
            name="typeOfRefund"
            checked={isFullRefund}
            onChange={() => {}}
          />
          <span className="m-1">Full Refund</span>
        </button>
        <button
          type="button"
          className="btn btn-outline-white"
          onClick={() => this.onPartialRefundClick(!isPartialRefund)}
          disabled={allowPartial}
        >
          <input
            className="form-control-input"
            type="radio"
            name="typeOfRefund"
            checked={isPartialRefund}
            onChange={() => {}}
            disabled={allowPartial}
          />
          <span className="m-1">{partialOnly ? 'Refund' : 'Partial Refund'}</span>
        </button>
      </FieldSet>
    );
  }

  refundingPosTransaction() {
    const { data, } = this.props;
    return data.transaction.paymentProcessor === WORLDPAY_EXPRESS;
  }

  render() {
    const { forward, back, data, } = this.props;
    if (this.isValid()) {
      this.populateData();
    }
    return (
      <div>
        {data.getDetails()}
        {this.getRefundView()}
        <div className="row justify-content-center mt-3">
          <div>
            <button type="button" className="btn btn-light m-1" onClick={back}>
              previous
            </button>
            <button
              type="button"
              className="btn btn-light m-1"
              disabled={!this.isValid()}
              onClick={forward}
            >
              next
            </button>
          </div>
        </div>
      </div>
    );
  }
}

RefundOptions.propTypes = {
  data: PropTypes.object.isRequired,
  forward: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
};
export default RefundOptions;
